import { isLogEnabled, SdkFlowSelection } from './constants';
import { addEventToQueue, getPostHogInstance } from './postHogUtils';
import {
  getIsLoanJourney,
  getIsNewUser,
  getTenant,
  getTrackingId,
  getSdkFlowSelection,
  getUserId,
} from './storageUtils';
import { TenantType } from './types';
import { AppBridge } from '../App';
import { getEventConfig } from './jfsEventMapping';

export const pushEventToParent = ({
  eventCode,
  errorMessage,
  errorStatus,
  meta,
  postHogEventName,
}: {
  eventCode: string;
  errorMessage?: string;
  errorStatus?: string | null;
  meta?: object;
  postHogEventName?: string;
}) => {
  pushEventToPosthog({
    eventCode: postHogEventName ? postHogEventName : eventCode,
    errorStatus,
    errorMessage,
    meta,
  });

  if (getTenant() === null) {
    if (window.opener) {
      window.opener.postMessage(
        JSON.stringify({
          trackingId: getTrackingId(),
          eventCode: eventCode,
          eventStatus: errorStatus,
          errorMessage: errorMessage,
          timeStamp: new Date(),
          meta: meta,
        }),
        '*'
      );
    } else {
      window.parent.postMessage(
        JSON.stringify({
          trackingId: getTrackingId(),
          eventCode: eventCode,
          eventStatus: errorStatus,
          errorMessage: errorMessage,
          timeStamp: new Date(),
          meta: meta,
        }),
        '*'
      );
    }
    if ((window as any).flutter_inappwebview) {
      (window as any)?.flutter_inappwebview.callHandler(
        'messageEventListener',
        JSON.stringify({
          trackingId: getTrackingId(),
          eventCode: eventCode,
          eventStatus: errorStatus,
          errorMessage: errorMessage,
          timeStamp: new Date(),
          meta: meta,
        })
      );
    } else if ((window as any)?.ReactNativeWebView) {
      (window as any)?.ReactNativeWebView?.postMessage(
        JSON.stringify({
          trackingId: getTrackingId(),
          eventCode: eventCode,
          eventStatus: errorStatus,
          errorMessage: errorMessage,
          timeStamp: new Date(),
          meta: meta,
        })
      );
    } else if ((window as any)?.SendEventToParent?.showData) {
      (window as any).SendEventToParent.showData(
        JSON.stringify({
          trackingId: getTrackingId(),
          eventCode: eventCode,
          eventStatus: errorStatus,
          errorMessage: errorMessage,
          timeStamp: new Date(),
          meta: meta,
        })
      );
    }
  } else {
    if (getTenant() === TenantType.PB) {
      window.parent.postMessage(
        JSON.stringify({
          trackingId: getTrackingId(),
          eventCode: eventCode,
          eventStatus: errorStatus,
          errorMessage: errorMessage,
          timeStamp: new Date(),
          meta: meta,
        }),
        '*'
      );
    } else if (getTenant() === TenantType.JFS) {
      const eventConfig = getEventConfig(eventCode);
      const appEventName = eventConfig?.appEventName || eventCode;
      AppBridge.sendEventToApp(appEventName);
    } else if (
      getTenant() === TenantType.YESBANK ||
      getTenant() === TenantType.MAHINDRA
    ) {
      if ((window as any).flutter_inappwebview) {
        (window as any)?.flutter_inappwebview.callHandler(
          'messageEventListener',
          JSON.stringify({
            trackingId: getTrackingId(),
            eventCode: eventCode,
            eventStatus: errorStatus,
            errorMessage: errorMessage,
            timeStamp: new Date(),
            meta: meta,
          })
        );
      } else if ((window as any)?.ReactNativeWebView) {
        (window as any)?.ReactNativeWebView?.postMessage(
          JSON.stringify({
            trackingId: getTrackingId(),
            eventCode: eventCode,
            eventStatus: errorStatus,
            errorMessage: errorMessage,
            timeStamp: new Date(),
            meta: meta,
          })
        );
      } else {
        if (window.opener) {
          window.opener.postMessage(
            JSON.stringify({
              trackingId: getTrackingId(),
              eventCode: eventCode,
              eventStatus: errorStatus,
              errorMessage: errorMessage,
              timeStamp: new Date(),
              meta: meta,
            }),
            '*'
          );
        } else {
          window.parent.postMessage(
            JSON.stringify({
              trackingId: getTrackingId(),
              eventCode: eventCode,
              eventStatus: errorStatus,
              errorMessage: errorMessage,
              timeStamp: new Date(),
              meta: meta,
            }),
            '*'
          );
        }
      }
    } else {
      if ((window as any)?.SendEventToParent?.showData) {
        (window as any).SendEventToParent.showData(
          JSON.stringify({
            trackingId: getTrackingId(),
            eventCode: eventCode,
            eventStatus: errorStatus,
            errorMessage: errorMessage,
            timeStamp: new Date(),
            meta: meta,
          })
        );
      }
      window.parent.postMessage(
        JSON.stringify({
          trackingId: getTrackingId(),
          eventCode: eventCode,
          eventStatus: errorStatus,
          errorMessage: errorMessage,
          timeStamp: new Date(),
          meta: meta,
        }),
        '*'
      );
    }
  }
};

export const pushEventToPosthog = ({
  eventCode,
  errorMessage,
  errorStatus,
  meta,
}: {
  eventCode: string;
  errorMessage?: string;
  errorStatus?: string | null;
  meta?: any;
}) => {
  let eventCodeLoan;
  if (getTenant() === TenantType.YESBANK) {
    if (getIsNewUser()) {
      eventCodeLoan = 'YBL_' + eventCode;
    } else {
      if (eventCode.endsWith('_EXISTING_USER')) {
        eventCodeLoan = 'YBL_' + eventCode;
      } else {
        eventCodeLoan = 'YBL_' + eventCode + '_EXISTING_USER';
      }
    }
  } else if (getTenant() === TenantType.JFS) {
    if (getIsNewUser()) {
      eventCodeLoan = 'JFS_' + eventCode;
    } else {
      if (eventCode.endsWith('_EXISTING_USER')) {
        eventCodeLoan = 'JFS_' + eventCode;
      } else {
        eventCodeLoan = 'JFS_' + eventCode + '_EXISTING_USER';
      }
    }
  } else if (getIsLoanJourney()) {
    eventCodeLoan = 'LOAN_' + eventCode;
  } else {
    if (getIsNewUser()) {
      eventCodeLoan = eventCode;
    } else {
      if (eventCode.endsWith('_EXISTING_USER')) {
        eventCodeLoan = eventCode;
      } else {
        eventCodeLoan = eventCode + '_EXISTING_USER';
      }
    }
  }

  if (isLogEnabled) {
    console.log('postHogEventCode: ', eventCodeLoan);
  }
  let finalMeta = meta;
  if (getTenant() === TenantType.PB && getSdkFlowSelection()) {
    finalMeta = {
      ...meta,
      SdkFlowSelection: SdkFlowSelection.SHOW_FIP_SELECTION,
    };
  }

  if (getPostHogInstance() && getPostHogInstance().isIdentificationDone) {
    getPostHogInstance().capture(eventCodeLoan, {
      trackingId: getTrackingId(),
      userId: getUserId(),
      eventCode: eventCodeLoan,
      eventStatus: errorStatus,
      errorMessage: errorMessage,
      timeStamp: new Date(),
      meta: finalMeta,
    });
  } else {
    addEventToQueue(eventCodeLoan, {
      trackingId: getTrackingId(),
      eventCode: eventCodeLoan,
      eventStatus: errorStatus,
      errorMessage: errorMessage,
      timeStamp: new Date(),
      meta: finalMeta,
    });
  }
};

export const EVENTCODES = {
  HOME_CLICKED: 'HOME_CLICKED',
  ADD_ACCOUNT_FD_RD: 'ADD_ACCOUNT_FD_RD',
  DASHBOARD_VIEW: 'DASHBOARD_VIEW',
  DASHBOARD_EXIT: 'DASHBOARD_EXIT',
  RECEIVED_AUTO_READ_EVENT: 'RECEIVED_AUTO_READ_EVENT',
  ASSETS_FETCH_SUCCESS: 'ASSETS_FETCH_SUCCESS',
  RAW_DATA_FETCHED: 'RAW_DATA_FETCHED',
  NO_SESSION_ID: 'NO_SESSION_ID',
  QUERY_PARAMS_INFO: 'QUERY_PARAMS_INFO',
  FIP_CONFIRM_BUTTON_CLICKED: 'FIP_CONFIRM_BUTTON_CLICKED',
  FIP_SELECTED: 'FIP_SELECTED',
  FIP_SELECTED_YES_BANK: 'FIP_SELECTED_YES_BANK',
  CONNECT_BUTTON_CLICKED: 'CONNECT_BUTTON_CLICKED',
  FIP_LIST_FETCHED: 'FIP_LIST_FETCHED',
  FIP_LIST_FAILED: 'FIP_LIST_FAILED',
  FETCHING_FIP_LIST: 'FETCHING_FIP_LIST',
  SESSION_TIMEOUT: 'SESSION_TIMEOUT',
  SESSION_TIMEOUT_MDS: 'SESSION_TIMEOUT_MDS',
  STATUS_POLLING: 'STATUS_POLLING',
  EMAIL_MDS: 'EMAIL_MDS',
  METADATA_RECEIVED: 'METADATA_RECEIVED',
  PFM_JOURNEY: 'PFM_JOURNEY',
  LOAN_JOURNEY: 'JOURNEY',
  NEW_AUTH_PAGE_LOADED: 'NEW_AUTH_PAGE_LOADED',
  FIP_PAGE_LOADED: 'FIP_PAGE_LOADED',
  STOCKS_NEW_USER: 'STOCKS_NEW_USER',
  JOURNEY_STARTED: 'JOURNEY_STARTED',
  JOURNEY_STARTED_EXISTING_USER: 'JOURNEY_STARTED_EXISTING_USER',
  JOURNEY_STARTED_NEW_USER: 'JOURNEY_STARTED_NEW_USER',
  DASHBOARD_LOAD: 'DASHBOARD_LOAD',
  BANK_ACCOUNT_CLICKED: 'BANK_ACCOUNT_CLICKED',
  MF_ACCOUNT_CLICKED: 'MF_ACCOUNT_CLICKED',
  BACK_BUTTON_MF: 'BACK_BUTTON_MF',
  STOCKS_CLICKED: 'STOCKS_CLICKED',
  MUTUAL_FUNDS_CLICKED: 'MUTUAL_FUNDS_CLICKED',
  BANNER_CLICKED: 'BANNER_CLICKED',
  INSIGHTS_VIEW_ALL: 'INSIGHTS_VIEW_ALL',
  FAQ_CLICKED: 'FAQ_CLICKED',
  INSIGHT_INTEREST: 'INSIGHT_INTEREST',
  INSIGHT_BANKCHARGES: 'INSIGHT_BANKCHARGES',
  INSIGHT_DIVIDEND: 'INSIGHT_DIVIDEND',
  INSIGHT_SALARY: 'INSIGHT_SALARY',
  INSIGHT_EMI: 'INSIGHT_EMI',
  INSIGHT_TRAVEL: 'INSIGHT_TRAVEL',
  INSIGHT_SIP: 'INSIGHT_SIP',
  INSIGHT_MINBALCHARGES: 'INSIGHT_MINBALCHARGES',
  INSIGHT_CB: 'INSIGHT_CB',
  INSIGHT_REFUND: 'INSIGHT_REFUND',
  BACK_BUTTON_PFMDB: 'BACK_BUTTON_PFMDB',
  BANK_DASHBOARD: 'BANK_DASHBOARD',
  BANK_CLICKED_1: 'BANK_CLICKED_1',
  BANK_CLICKED_2: 'BANK_CLICKED_2',
  BANK_CLICKED_3: 'BANK_CLICKED_3',
  BANK_CLICKED_4: 'BANK_CLICKED_4',
  ADD_ACCOUNT_BANKS: 'ADD_ACCOUNT_BANKS',
  ADD_ACCOUNT_STOCKS: 'ADD_ACCOUNT_STOCKS',
  ADD_ACCOUNT_MF: 'ADD_ACCOUNT_MF',
  SUMMARY_INCOMING: 'SUMMARY_INCOMING',
  SUMMARY_EXPENSES: 'SUMMARY_EXPENSES',
  SUMMARY_INVESTMENT: 'SUMMARY_INVESTMENT',
  FILTER_BANK_DB: 'FILTER_BANK_DB',
  FILTER_DATE: 'FILTER_DATE',
  MONTHLY_PAYMENTS: 'MONTHLY_PAYMENTS',
  ACCOUNT_STATEMENT: 'ACCOUNT_STATEMENT',
  ACCOUNT_INSIGHTS: 'ACCOUNT_INSIGHTS',
  TRANSACTION_CAT: 'TRANSACTION_CAT',
  BANK_DETAILS: 'BANK_DETAILS',
  ACCOUNT_DETAILS: 'ACCOUNT_DETAILS',
  BANK_FILTER: 'BANK_FILTER',
  VIEW_ALL_TRANSACTIONS: 'VIEW_ALL_TRANSACTIONS',
  VIEW_ALL_RECURRING: 'VIEW_ALL_RECURRING',
  BACK_BUTTON_BANK: 'BACK_BUTTON_BANK',
  BACK_BUTTON_BANK_ACCOUNT: 'BACK_BUTTON_BANK_ACCOUNT',
  CATEGORIES: 'CATEGORIES',
  INCOMING_CAT: 'INCOMING_CAT',
  EXPENSES_CAT: 'EXPENSES_CAT',
  DATE: 'DATE',
  BACK_BUTTON_CATEGORIES: 'BACK_BUTTON_CATEGORIES',
  INSIGHTS_VIEW: 'INSIGHTS_VIEW',
  INSIGHTS_CLICKED: 'INSIGHTS_CLICKED',
  BACK_BUTTON_INSIGHTS: 'BACK_BUTTON_INSIGHTS',
  CATEGORY: 'CATEGORY',
  TRANSACTIONS: 'TRANSACTIONS',
  FILTER_TRANSACTIONS: 'FILTER_TRANSACTIONS',
  BACK_BUTTON_TRANSACTIONS: 'BACK_BUTTON_TRANSACTIONS',
  BACK_BUTTON_RECURRING: 'BACK_BUTTON_RECURRING',
  MY_MONTHLY_PAYMENT_CLICKED: 'MY_MONTHLY_PAYMENT_CLICKED',
  REVOKE_YOUR_CONSENT_CLICKED: 'REVOKE_YOUR_CONSENT_CLICKED',
  REVOKE_CONSENT_SUCCESS: 'REVOKE_CONSENT_SUCCESS',
  REVOKE_CONSENT_FAILED: 'REVOKE_CONSENT_FAILED',
  GO_BACK_CONSENT_REVOKE: 'GO_BACK_CONSENT_REVOKE',
  CONSENT_REVOKE_CLICKED: 'CONSENT_REVOKE_CLICKED',
  USER_INITIATED_REFRESH_BUTTON_CLICKED:
    'USER_INITIATED_REFRESH_BUTTON_CLICKED',
  REFRESH_FAILED: 'REFRESH_FAILED',
  REFRESH_PROCESSING: 'REFRESH_PROCESSING',
  REFRESH_COMPLETED_PARTIAL: 'REFRESH_COMPLETED_PARTIAL',
  REFRESH_COMPLETED: 'REFRESH_COMPLETED',
  AUTO_REFRESH: 'AUTO_REFRESH',
  BACK_BUTTON_PRESSED_AA: 'BACK_BUTTON_PRESSED_AA',
  BACK_BUTTON_PRESSED: 'BACK_BUTTON_PRESSED',
  NUDGE_VIEWED: 'NUDGE_VIEWED',
  NUDGE_CLICKED: 'NUDGE_CLICKED',
  NUDGE_RENDER: 'NUDGE_RENDER',
  WELCOME_SCREEN_ASSET_MF_LINK_CLICKED: 'WELCOME_SCREEN_ASSET_MF_LINK_CLICKED',
  WELCOME_SCREEN_ASSET_BANK_LINK_CLICKED:
    'WELCOME_SCREEN_ASSET_BANK_LINK_CLICKED',
  WELCOME_SCREEN_ASSET_STOCKS_LINK_CLICKED:
    'WELCOME_SCREEN_ASSET_STOCKS_LINK_CLICKED',
  WELCOME_SCREEN_VIEWED: 'WELCOME_SCREEN_VIEWED',
  ASSETS_DASHBOARD_ADD_ASSETS_CLICKED: 'ASSETS_DASHBOARD_ADD_ASSETS_CLICKED',
  TOGGLE_AMOUNTS_CLICKED: 'TOGGLE_AMOUNTS_CLICKED',
  ASSET_BANK_LINK_CLICKED: 'ASSET_BANK_LINK_CLICKED',
  ASSET_STOCKS_LINK_CLICKED: 'ASSET_STOCKS_LINK_CLICKED',
  ASSET_MUTUAL_FUND_LINK_CLICKED: 'ASSET_MUTUAL_FUND_LINK_CLICKED',
  BANK_CLICKED: 'BANK_CLICKED',
  ASSETS_DASHBOARD_VIEWED: 'ASSETS_DASHBOARD_VIEWED',
  ADD_ASSET_DRAWER_VIEWED: 'ADD_ASSET_DRAWER_VIEWED',
  ADD_ASSET_DRAWER_SAVINGS_CLICKED: 'ADD_ASSET_DRAWER_SAVINGS_CLICKED',
  ADD_ASSET_DRAWER_STOCKS_ETFS_CLICKED: 'ADD_ASSET_DRAWER_STOCKS_ETFS_CLICKED',
  ADD_ASSET_DRAWER_MUTUAL_FUNDS_CLICKED:
    'ADD_ASSET_DRAWER_MUTUAL_FUNDS_CLICKED',
  DASHBOARD_CASHFLOW_TAB_CLICKED_OVERVIEW:
    'DASHBOARD_CASHFLOW_TAB_CLICKED_OVERVIEW',
  DASHBOARD_CASHFLOW_TAB_CLICKED_MONEY_IN:
    'DASHBOARD_CASHFLOW_TAB_CLICKED_MONEY_IN',
  DASHBOARD_CASHFLOW_TAB_CLICKED_MONEY_OUT:
    'DASHBOARD_CASHFLOW_TAB_CLICKED_MONEY_OUT',
  DASHBOARD_CASHFLOW_MONTH_PERIOD_CLICKED:
    'DASHBOARD_CASHFLOW_MONTH_PERIOD_CLICKED',
  ACCOUNTS_L1_GRAPH_CLICKED: 'ACCOUNTS_L1_GRAPH_CLICKED',
  ACCOUNTS_L1_CHEVRON_CLICKED_BANK: 'ACCOUNTS_L1_CHEVRON_CLICKED_BANK',
  BACK_BUTTON_CLICKED: 'BACK_BUTTON_CLICKED',
  ACCOUNTS_INSIGHT_CARD_CLICKED: 'ACCOUNTS_INSIGHT_CARD_CLICKED',
  ACCOUNTS_L1_ADD_ACCOUNT_CLICKED: 'ACCOUNTS_L1_ADD_ACCOUNT_CLICKED',
  ACCOUNTS_L1_ALL_TRANSACTIONS_CLICKED: 'ACCOUNTS_L1_ALL_TRANSACTIONS_CLICKED',
  ACC_L1_CASHFLOW_TAB_CLICKED_OVERVIEW: 'ACC_L1_CASHFLOW_TAB_CLICKED_OVERVIEW',
  ACC_L1_CASHFLOW_TAB_CLICKED_MONEYIN: 'ACC_L1_CASHFLOW_TAB_CLICKED_MONEYIN',
  ACC_L1_CASHFLOW_TAB_CLICKED_MONEYOUT: 'ACC_L1_CASHFLOW_TAB_CLICKED_MONEYOUT',
  ACC_L1_CASHFLOW_MONTH_PERIOD_CLICKED: 'ACC_L1_CASHFLOW_MONTH_PERIOD_CLICKED',
  ACCOUNTS_L1_FAQ_MENU_CLICKED: 'ACCOUNTS_L1_FAQ_MENU_CLICKED',
  ACCOUNTS_L1_REMOVE_ACCOUNT_MENU_CLICKED:
    'ACCOUNTS_L1_REMOVE_ACCOUNT_MENU_CLICKED',
  BANK_REMOVE_ACCOUNT_CTA_CLICKED: 'BANK_REMOVE_ACCOUNT_CTA_CLICKED',
  BANK_KEEP_ACCOUNT_CTA_CLICKED: 'BANK_KEEP_ACCOUNT_CTA_CLICKED',
  BANK_REMOVE_ACCOUNT_FAILURE: 'BANK_REMOVE_ACCOUNT_FAILURE',
  BANK_REMOVE_ACCOUNT_SUCCESS: 'BANK_REMOVE_ACCOUNT_SUCCESS',
  BANK_REMOVE_ACCOUNT_TRY_AGAIN_CLICKED:
    'BANK_REMOVE_ACCOUNT_TRY_AGAIN_CLICKED',
  ALL_TRANSACTIONS_VIEWED: 'ALL_TRANSACTIONS_VIEWED',
  ALL_TRANSACTIONS_BACK_CLICKED: 'ALL_TRANSACTIONS_BACK_CLICKED',
  ALL_TRANSACTIONS_FILTER_MODAL_OPENED: 'ALL_TRANSACTIONS_FILTER_MODAL_OPENED',
  ALL_TRANSACTIONS_FILTER_APPLIED: 'ALL_TRANSACTIONS_FILTER_APPLIED',
  ALL_TRANSACTIONS_FILTER_CLEARED: 'ALL_TRANSACTIONS_FILTER_CLEARED',
  ACCOUNTS_L2_VIEWED: 'ACCOUNTS_L2_VIEWED',
  ACCOUNTS_L2_BACK_CLICKED: 'ACCOUNTS_L2_BACK_CLICKED',
  ACCOUNTS_L2_GRAPH_CLICKED: 'ACCOUNTS_L2_GRAPH_CLICKED',
  ACCOUNTS_L2_ALL_TRANSACTIONS_CLICKED: 'ACCOUNTS_L2_ALL_TRANSACTIONS_CLICKED',
  ACCOUNTS_L2_CATEGORY_ITEM_CLICKED: 'ACCOUNTS_L2_CATEGORY_ITEM_CLICKED',
  ACC_L2_CASHFLOW_TAB_CLICKED_OVERVIEW: 'ACC_L2_CASHFLOW_TAB_CLICKED_OVERVIEW',
  ACC_L2_CASHFLOW_TAB_CLICKED_MONEYIN: 'ACC_L2_CASHFLOW_TAB_CLICKED_MONEYIN',
  ACC_L2_CASHFLOW_TAB_CLICKED_MONEYOUT: 'ACC_L2_CASHFLOW_TAB_CLICKED_MONEYOUT',
  CASHFLOW_TAB_MONTHS_SELECTION: 'CASHFLOW_TAB_MONTHS_SELECTION',
  ACCOUNTS_L2_INSIGHT_CARD_CLICKED: 'ACCOUNTS_L2_INSIGHT_CARD_CLICKED',
  STOCKS_ETFS_VIEWED: 'STOCKS_ETFS_VIEWED',
  STOCKS_ETFS_INSIGHT_CARD_CLICKED: 'STOCKS_ETFS_INSIGHT_CARD_CLICKED',
  STOCKS_ETFS_FUND_DISTRIBUTION_INFO_CLICKED:
    'STOCKS_ETFS_FUND_DISTRIBUTION_INFO_CLICKED',
  STOCKS_ETFS_SORT_OPENED: 'STOCKS_ETFS_SORT_OPENED',
  STOCKS_ETFS_FILTER_OPENED: 'STOCKS_ETFS_FILTER_OPENED',
  STOCKS_ETFS_SORT_APPLIED: 'STOCKS_ETFS_SORT_APPLIED',
  STOCKS_ETFS_FILTER_APPLIED: 'STOCKS_ETFS_FILTER_APPLIED',
  STOCKS_ETFS_FILTER_CLEAR_ALL_CLICKED: 'STOCKS_ETFS_FILTER_CLEAR_ALL_CLICKED',
  STOCKS_ETFS_REMOVE_ACCOUNT_CLICKED: 'STOCKS_ETFS_REMOVE_ACCOUNT_CLICKED',
  STOCKS_ETFS_HOLDING_CLICKED: 'STOCKS_ETFS_HOLDING_CLICKED',
  STOCKS_ETFS_REMOVE_CTA_CLICKED: 'STOCKS_ETFS_REMOVE_CTA_CLICKED',
  STOCKS_ETFS_KEEP_CTA_CLICKED: 'STOCKS_ETFS_KEEP_CTA_CLICKED',
  STOCKS_ETFS_REMOVE_SUCCESS: 'STOCKS_ETFS_REMOVE_SUCCESS',
  STOCKS_ETFS_REMOVE_FAILURE: 'STOCKS_ETFS_REMOVE_FAILURE',
  STOCKS_ETFS_REMOVE_TRY_AGAIN_CLICKED: 'STOCKS_ETFS_REMOVE_TRY_AGAIN_CLICKED',
  ETF_TOP_HOLDINGS_VIEW_ALL_BACK_CLICKED:
    'ETF_TOP_HOLDINGS_VIEW_ALL_BACK_CLICKED',
  ETF_MARKET_CAP_DISTRIBUTION_INFO_CLICKED:
    'ETF_MARKET_CAP_DISTRIBUTION_INFO_CLICKED',
  STOCKS_FUNDAMENTALS_INFO_CLICKED: 'STOCKS_FUNDAMENTALS_INFO_CLICKED',
  TOP_HOLDINGS_VIEW_ALL_CLICKED: 'TOP_HOLDINGS_VIEW_ALL_CLICKED',
  SECTOR_ALLOCATION_VIEW_ALL_CLICKED: 'SECTOR_ALLOCATION_VIEW_ALL_CLICKED',
  ACCOUNTS_L1_VIEWED: 'ACCOUNTS_L1_VIEWED',
  STOCKS_L2_VIEWED: 'STOCKS_L2_VIEWED',
  ETF_L2_VIEWED: 'ETF_L2_VIEWED',

  // Mutual Funds events
  MFS_SORT_OPENED: 'MFS_SORT_OPENED',
  MFS_FILTER_OPENED: 'MFS_FILTER_OPENED',
  MFS_SORT_APPLIED: 'MFS_SORT_APPLIED',
  MFS_FILTER_APPLIED: 'MFS_FILTER_APPLIED',
  MFS_FILTER_CLEAR_ALL_CLICKED: 'MFS_FILTER_CLEAR_ALL_CLICKED',
  MFS_REMOVE_CTA_CLICKED: 'MFS_REMOVE_CTA_CLICKED',
  MFS_KEEP_CTA_CLICKED: 'MFS_KEEP_CTA_CLICKED',
  MFS_REMOVE_SUCCESS: 'MFS_REMOVE_SUCCESS',
  MFS_REMOVE_FAILURE: 'MFS_REMOVE_FAILURE',
  MFS_REMOVE_TRY_AGAIN_CLICKED: 'MFS_REMOVE_TRY_AGAIN_CLICKED',
  MFS_SEARCH_OPENED: 'MFS_SEARCH_OPENED',
  MFS_FUND_CARD_CLICKED: 'MFS_FUND_CARD_CLICKED',
  MFS_VIEW_ALL_HOLDINGS_CLICKED: 'MFS_VIEW_ALL_HOLDINGS_CLICKED',
  HOLDINGS_PAGE_BACK_CLICKED: 'HOLDINGS_PAGE_BACK_CLICKED',
  MFS_REMOVE_ACCOUNT_CLICKED: 'MFS_REMOVE_ACCOUNT_CLICKED',
  MF_FUND_DISTRIBUTION_INFO_CLICKED_L1: 'MF_FUND_DISTRIBUTION_INFO_CLICKED_L1',
  MF_FUND_DISTRIBUTION_INFO_CLICKED_L2: 'MF_FUND_DISTRIBUTION_INFO_CLICKED_L2',
  FAQ_VIEWED: 'FAQ_VIEWED',
  MF_HOLDING_CLICKED: 'MF_HOLDING_CLICKED',
  MFS_L1_PAGE_VIEWED: 'MFS_L1_PAGE_VIEWED',
  MFS_L2_PAGE_VIEWED: 'MFS_L2_PAGE_VIEWED',
  STKS_ETFS_IFUND_DIST_INFO_CLICKED: 'STKS_ETFS_IFUND_DIST_INFO_CLICKED',
  ERROR_BOUNDARY_TRIGGERED: 'ERROR_BOUNDARY_TRIGGERED',
};
